import { WorkflowDataValue } from "../modules/fintech/models/work-flow-data-field.model";

export class CompanyNote {
  fiscalId: string;
  notes?: { [key: string]: WorkflowDataValue };
}